export enum EAuthFormTokenHandling {
    OTP_TOKEN_SENT = "otp_token_sent",
    LAST_USED_AUTH_TOKEN = "last_used_auth_token",
    BOTH = "both",
}
